<template>
  <v-tooltip
    v-if="disabled && isForSignUp"
    location="bottom"
    :open-delay="100"
  >
    <template #activator="{ props }">
      <div v-bind="props" style="width: 100%;">
        <v-btn
          variant="outlined"
          class="google-cta"
          :disabled="true"
        >
          <div class="google-cta__logo-container">
            <div class="google-logo-bg">
              <img src="@/assets/icon-google-svg.svg" alt="G" />
            </div>
          </div>
          <div class="google-cta__text-container">
            <span class="google-cta__text">Sign up with Google</span>
          </div>
        </v-btn>
      </div>
    </template>
    <span>
      <v-icon size="14" class="mr-1">mdi-information-outline</v-icon>
      Please agree to the Terms of Service first
    </span>
  </v-tooltip>

  <v-btn
    v-else
    variant="outlined"
    class="google-cta"
    @click="googleSignIn"
    :disabled="disabled"
  >
    <div class="google-cta__logo-container">
      <div class="google-logo-bg">
        <img src="@/assets/icon-google-svg.svg" alt="G" />
      </div>
    </div>
    <div class="google-cta__text-container">
      <span class="google-cta__text">
        {{ isForSignUp ? 'Sign up with Google' : 'Continue with Google' }}
      </span>
    </div>
  </v-btn>
</template>

<script setup>
import { Auth, CognitoHostedUIIdentityProvider } from '@aws-amplify/auth'
import { useRoute } from 'vue-router'

defineProps({
  isForSignUp: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const route = useRoute()

const googleSignIn = () => {
  const projectId = route.query.projectId
  const redirect = route.query.redirect
  const state = projectId || redirect ? JSON.stringify({ projectId, redirect }) : undefined
  Auth.federatedSignIn({
    provider: CognitoHostedUIIdentityProvider.Google,
    customState: state
  })
}
</script>
<style>

a {
  color: rgba(0, 0, 0, 0.87);
}

.google-logo-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  padding: 4px;
  border-radius: 4px;

  & img {
    width: 100%;
    height: 100%;
  }
}

.google-cta {
  &.v-btn {
    border-color: #dadce0 !important;
    border-radius: 8px !important;
    padding: 11px !important;
    display: block !important;
    width: 100%;
    height: auto !important;
    background: #fff !important;
    color: #5f6368 !important;
    font-size: 14px !important;
    font-style: normal;
    text-transform: none !important;
    font-family: Inter, Arial, sans-serif;
    line-height: 24px;
    letter-spacing: 0.25px;
    box-shadow: none !important;

    &:hover {
      background: #f8f9fa !important;
    }

    &.v-btn--size-default.v-btn--variant-outlined:disabled {
      opacity: 1 !important;

      & .v-btn__overlay {
        border-radius: 7px;
        opacity: 0.46 !important;
        background: #5f6368;
      }
    }

    > .v-btn__content {
      justify-content: left;

      > .google-cta__text-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
      }
    }
  }
}

[data-theme="dark"] .google-cta {
  &.v-btn {
    background: var(--surface-elevated) !important;
    color: var(--text-dark) !important;
    border-color: var(--diagram-border) !important;

    &:hover {
      background: var(--light-4) !important;
    }
  }
}
</style>
